<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { store } from './store'


export default {
  name: 'App',
  store
}
</script>


<style lang="scss">


// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #000028;
$warning: #FFD732;
$dark: #333353;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);
$modal-card-head-background-color: #000028;
$modal-card-title-color: white;
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>

<style>
.shift-down{
margin-top: 8px;
padding-top: 8px;
}

.shift-up{
margin-top: -8px;
padding-top: -8px;
}
</style>
